import { apiClient, unwrap } from './client';

export interface UserAdmin {
  id:          string;
  email:       string;
  fullName:    string;
  role:        string;
  phone:       string | null;
  filialeCode: string;
  isActive:    boolean;
  lastLoginAt: string | null;
  createdAt:   string;
}

export interface CreateUserPayload {
  email:             string;
  fullName:          string;
  role:              'admin_holding' | 'auditeur' | 'dg_filiale' | 'daf' | 'manager' | 'rh' | 'acheteur' | 'commercial' | 'chef_equipe';
  targetFilialeKey?: string;
  password?:         string;
  phone?:            string;
}

export interface CreateUserResponse {
  id:              string;
  email:           string;
  fullName:        string;
  role:            string;
  filialeCode:     string;
  tenantKey:       string;
  initialPassword: string;
}

export const usersApi = {
  list: async (): Promise<UserAdmin[]> => {
    const r = await apiClient.get('/users');
    return unwrap<UserAdmin[]>(r);
  },
  create: async (payload: CreateUserPayload): Promise<CreateUserResponse> => {
    const r = await apiClient.post('/users', payload);
    return unwrap<CreateUserResponse>(r);
  },
};
